import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const GET_PROPERTY_TYPE_API = `${LOCAL_URL}/property/propertyType`
export const GET_CARPET_AREA_UNIT_API = `${LOCAL_URL}/property/carpetAreaUnit`
export const GET_COUNTRY_API = `${LOCAL_URL}/getCountry`
export const GET_PROVINCE_API = `${LOCAL_URL}/getProvince`
export const CREATE_PROPERTT_API = `${LOCAL_URL}/property/createProperty`
export const GET_PROPERTY_LIST_API = `${LOCAL_URL}/property/listProperty`
export const GET_DOC_TYPE_API = `${LOCAL_URL}/property/propertyDocumentType`
export const POST_DOC = `${LOCAL_URL}/propertyDocUpload`
export const UPLOAD_IMG_API = `${LOCAL_URL}/propertyImageUpload`
export const GET_SUCCESS_IMG = `${LOCAL_URL}/property/propertyImage`
export const GET_SUCCESS_DOC = `${LOCAL_URL}/property/propertyDocument`
export const PROPERTY_INVENTORY = `${LOCAL_URL}/property/listPropertyInventory`
export const GET_IMAGE_DISPLAY_API = `${LOCAL_URL}/property/propertyImage`
export const DISPLAY_IMAGE = `${LOCAL_URL}/static/uploads/property_img`
export const BLOCK_PROPERTY = `${LOCAL_URL}/property/blockProperty`
export const UNBLOCK_PROPERTY = `${LOCAL_URL}/property/unblockProperty`
export const RENT_PAYMENT_LIST = `${LOCAL_URL}/property/propertyRentPaymentList`
export const TRIGGER_RENT_REMINDER = `${LOCAL_URL}/tenant/tenantPaymentDueAlert`
export const UPDATE_MANUAL_PAYMENT_UPLOAD = `${LOCAL_URL}/tenantPaymentUpload`
export const UPDATE_MANUAL_PAYMENT = `${LOCAL_URL}/tenant/updateManualPayment`
export const PAYMENT_METHOD_LIST = `${LOCAL_URL}/tenant/listPaymentMethod`
export const LIST_ALL_KYC = `${LOCAL_URL}/kyc/listAllKYC`
export const DOCUMENT_TEMPLATE = `${LOCAL_URL}/sign/propertySignDcs`
export const PROPERTY_BULK_UPLOAD = `${LOCAL_URL}/property/property_bulk_upload`
export const UTILITY_BULK_UPLOAD = `${LOCAL_URL}/invoice/utility_bulk_upload`
export const All_PROPERTY_REPORT = `${LOCAL_URL}/property/property_bulk_export`
export const PROPERTY_REPORT = `${LOCAL_URL}/property/subunits_reports_export`
export const Whatsapp_SEND = `${LOCAL_URL}/tenant/rental/whatsapp`

const headers = {
  Authorization: API_TOKEN,
  //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
}

// function to get property type
export async function Get_Property_Type() {
  const headers = {
    Authorization: API_TOKEN,
    //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
  return await axios.post(
    GET_PROPERTY_TYPE_API,

    {
      headers,
    }
  )
}

// function to get carpet area unit
export async function Get_Carpet_Unit() {
  const headers = {
    Authorization: API_TOKEN,
    // 'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
  return await axios.post(
    GET_CARPET_AREA_UNIT_API,

    {
      headers,
    }
  )
}

// function get country
export async function Get_Country() {
  return await axios.get(GET_COUNTRY_API)
}

// FUNCTION  TO GET Province
export async function Get_Province(country_id: number) {
  return await axios.post(GET_PROVINCE_API, { country_id })
}

// function to creacte property
export async function Create_Property(
  property_type_uuid: string,
  property_title: string,
  carpet_area: number,
  carpet_area_unit_uuid: string,
  address_1: string,
  address_2: string,
  country_id: number,
  province_id: number,
  city: string,
  pin_zip: number,
  current_rent: number,
  isAgent: boolean,
  owner_name: string,
  owner_email_id: string,
  owner_contact_number: string,
  sub_unit_available: boolean,
  property_usage_type: number,
  unitdetails: any
) {
  return await axios.post(CREATE_PROPERTT_API, {
    property_type_uuid,
    property_title,
    carpet_area,
    carpet_area_unit_uuid,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    current_rent,
    isAgent,
    owner_name,
    owner_email_id,
    owner_contact_number,
    sub_unit_available,
    property_usage_type,
    unitdetails,
  })
}

export async function Create_New_Property(
  property_type_uuid: string,
  property_title: string,
  carpet_area: string,
  carpet_area_unit_uuid: string,
  address_1: string,
  address_2: string,
  country_id: number,
  province_id: number,
  city: string,
  pin_zip: number,
  current_rent: number,
  account_kyc_uuid: string,
  isAgent: boolean,
  owner_name: string,
  owner_email_id: string,
  owner_contact_number: string,
  sub_unit_available: boolean,
  property_usage_type: number,
  property_furnishing_status: number,
  sub_units: any
) {
  return await axios.post(CREATE_PROPERTT_API, {
    property_type_uuid,
    property_title,
    carpet_area,
    carpet_area_unit_uuid,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    current_rent,
    account_kyc_uuid,
    isAgent,
    owner_name,
    owner_email_id,
    owner_contact_number,
    sub_unit_available,
    property_usage_type,
    property_furnishing_status,
    sub_units,
  })
}

export async function Get_Property_List(offset: number, limit: number, search: string) {
  return await axios.post(
    GET_PROPERTY_LIST_API, { offset, limit, search }
  )
}
export async function Upload_Doc(
  property_document_type_uuid: string,
  document_label: any,
  property_id: string,
  file: any
) {
  let data = {
    property_document_type_uuid: property_document_type_uuid,
    document_label: document_label,
    property_uuid: property_id,
    file: file,
  }

  return await axios.post(POST_DOC, data, {
    headers: { ...headers },
  })
}

// api to upload image
export async function Upload_Img(property_id: string, file: string) {
  let obj = {
    property_id: property_id,
    file: file,
  }
  return await axios.post(UPLOAD_IMG_API, obj)
}

interface filesDataType {
  file: string
}
// api to upload image
export async function New_Upload_Img(property_uuid: string, file: filesDataType[]) {
  let obj = {
    property_uuid: property_uuid,
    files: file,
  }
  return await axios.post(UPLOAD_IMG_API, obj)
}

/// function to show doc
export async function ShowDoc(obj: string) {
  let data = {
    property_uuid: obj,
  }
  return await axios.post(GET_SUCCESS_DOC, data, {
    headers: { ...headers },
  })
}
/// function to show doc
export async function getInventory(obj: string) {
  let data = {
    property_uuid: obj,
  }
  return await axios.post(PROPERTY_INVENTORY, data, {
    headers: { ...headers },
  })
}

// fucntion to show img
export async function ShowImg(obj: any) {
  let data = {
    property_uuid: obj,
  }

  return await axios.post(GET_SUCCESS_IMG, data, {
    headers: { ...headers },
  })
}

export async function Get_Doc_List() {
  return await axios.get(GET_DOC_TYPE_API)
}

export async function DisplyImg(obj: any) {
  return axios.get(`DISPLAY_IMAGE/${obj}`)
}

// function to block property
export async function blockProperty(property_uuid: string) {
  let data = {
    property_uuid: property_uuid,
  }
  return axios.post(BLOCK_PROPERTY, data)
}

// function to Unblock property
export async function unblockProperty(property_uuid: string) {
  let data = {
    property_uuid: property_uuid,
  }
  return axios.post(UNBLOCK_PROPERTY, data)
}

// function to get rent payment list
export async function getRentPaymentList(
  property_uuid: string,
  property_sub_unit_uuid: string = '',
  offset: number,
  limit: number
) {
  return axios.post(RENT_PAYMENT_LIST, { property_uuid, property_sub_unit_uuid, offset, limit })
}

// function to trigger rent reminder to tenant
export async function triggerRentReminder(tenant_rent_uuid: string) {
  return await axios.post(TRIGGER_RENT_REMINDER, { tenant_rent_uuid })
}

export async function tenantPaymentUpload(
  property_uuid: string,
  payment_type: string,
  tenant_utility_invoice_uuid: string,
  tenant_rent_uuid: string,
  rent_payment_file: string,
  utility_payment_file: string) {
  return await axios.post(UPDATE_MANUAL_PAYMENT_UPLOAD, {
    property_uuid,
    payment_type,
    tenant_utility_invoice_uuid,
    tenant_rent_uuid,
    rent_payment_file,
    utility_payment_file
  })
}

export async function tenantManualPayment(
  payment_type: string,
  tenant_utility_invoice_uuid: string,
  tenant_rent_uuid: string,
  payment_method_uuid: string,
  payment_reference: string) {
  return await axios.post(UPDATE_MANUAL_PAYMENT, {
    payment_type,
    tenant_utility_invoice_uuid,
    tenant_rent_uuid,
    payment_method_uuid,
    payment_reference
  })
}

// function to get list of payment methods
export async function getPaymentMethods() {
  return await axios.get(PAYMENT_METHOD_LIST)
}

// function to get all the KYC for the user
export async function getAllKYC() {
  return await axios.get(LIST_ALL_KYC)
}

// function to get property agreement list
export async function getDocumentTemplate(property_uuid: string) {
  return await axios.post(DOCUMENT_TEMPLATE, { property_uuid })
}

// Function to upload bulk properties
export async function propertyBulkUpload(file: string) {
  return await axios.post(PROPERTY_BULK_UPLOAD, { file })
}

// Function to upload bulk utilities
export async function utilityBulkUpload(file: string) {
  return await axios.post(UTILITY_BULK_UPLOAD, { file })
}

// Function to get the json data for all properties report 
export async function All_Property_Report() {
  return await axios.get(All_PROPERTY_REPORT)
}

// Function to get the json data for property report 
export async function Property_Report(property_uuid: string) {
  return await axios.post(PROPERTY_REPORT, { property_uuid })
}


// Function to send the whatsapp message
export async function sendWhatsappMessage(property_uuid: string) {
  return await axios.post(Whatsapp_SEND, { property_uuid })
}